import { Link } from 'react-router-dom'
import { Badge } from 'avo-ui'
import { formatDateMoment, setCurrency } from 'utils/utils'

export const TABLE_ORDER = {
    name: 'Order',
    column: [
        {
            name: 'Nomor Order',
            key: 'order_code',
            render: ({ item }) => (
                <Link
                    to={`/order/order-list/detail?orderId=${item?.id}`}
                    className={'font-medium text-blue-90 hover:font-bold hover:underline'}
                >
                    {item?.order_code}
                </Link>
            ),
        },
        {
            name: 'Tanggal Order',
            key: 'created_at',
            render: ({ value }) => formatDateMoment(value, 'DD MMM YYYY'),
        },
        {
            name: 'Total Order',
            key: 'grand_total',
            render: ({ value }) => <div>{setCurrency(value)}</div>,
        },
        {
            name: 'Status',
            key: 'status',
            render: ({ value }) => <Badge title={value} type={value} />,
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
}
